var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCf = function SvgCf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M22.54 6.26A12.027 12.027 0 0 0 15.13.412l-.522 5.848h7.933ZM1.459 6.26h7.932L8.87.413a12.027 12.027 0 0 0-7.41 5.849Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M14.608 12.002v5.739h7.933C23.47 16.036 24 14.08 24 12h-9.392ZM9.391 12H0c0 2.08.529 4.035 1.46 5.74H9.39V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M1.459 17.74a12.028 12.028 0 0 0 7.41 5.848l.522-5.115-7.932-.733ZM15.13 23.588a12.027 12.027 0 0 0 7.41-5.848l-7.932.734.522 5.114Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m14.608 18.474 7.933-.734h-7.933v.734ZM9.391 17.74H1.46l7.932.733v-.733Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 0c-1.083 0-2.132.145-3.13.414v23.173c.998.269 2.047.413 3.13.413 1.084 0 2.133-.144 3.131-.413V.414A12.013 12.013 0 0 0 12.001 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m6.454 2.61.324.996h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048l.323-.997Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCf;